import type { FaireProductEntity } from "../../entity_types/product";

export const p_vjm3sabmu5: FaireProductEntity = {
  token: "p_vjm3sabmu5",
  type: "product",
  name: "Playing Cards - Set of Two Decks - Fungi",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/7052103faedc439daa0287680ea57a95118e1d69d9c75e1ad50b4b9a86f808ab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c6c542aed2d840809d340bf7ec6045caa654bfdf0718326721a321ac6d9c958.jpeg",
    "https://cdn.faire.com/fastly/1f18f62210fac7cf49bf4fd494f8babc69d8854572d397ef5e34a00fd627e654.jpeg",
    "https://cdn.faire.com/fastly/94f2a60dd695d12b520fdab8e85b46ba930bd23d6252b711283b704e35059c53.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "This Set of Two 52-Deck Playing Cards features incredible vintage drawings of fungi species from England and Wales dating back to 1860. Roomytown's design team in Bath, UK, have carefully adapted and enhanced the original artwork and applied it to each of the playing cards in this Set of Two 52-Deck Playing Cards that come stored in a premium quality flip-top card hinged box.\n\nH 95mm x W 67mm x D 45mm / H 3.7” x 2.6” x D 1.8”\n\nExplore our wall prints and home decor, boasting charming designs for tea towels, trinket trays, playing cards, and notebooks. Embrace the upcoming seasons with delightful pieces perfect for gifting on occasions like Valentine's Day and Easter. Elevate your space with our unique home decor selections, capturing the essence of spring.\n\n Gifts For Her | Gifts for Him | Gifts for Kids",
  tags: [],
  msrpDollars: 27.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:40.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
